import React from 'react';
import $ from "jquery";
import Footerslider from '../components/FooterSlider/footerslider';
import { Link} from "react-router-dom";
import Header from '../modules/header'
import axios from 'axios';
import parse from 'html-react-parser';


import Bahamas from '../assets/images/Blog/Bahamas yacht charter.jpg';
import passenger from '../assets/images/Blog/Passenger yachts now.jpg';
import thanda from '../assets/images/Blog/Thanda Island triumphs.jpg';
import sardinia from '../assets/images/Blog/Sardinia yacht.jpg';
import offer from '../assets/images/yachts/offer-news-mobile.png';
import img1 from '../assets/images/yachts/image-38.png';
import img2 from '../assets/images/yachts/image-37.png';
import vector2 from '../assets/images/Blog/blog-vector2.svg';
import blogvector from '../assets/images/Blog/blog-vector1.svg';


class Blog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            featured_post: {},
            posts: [],
            blog_content: {},
            next_page: 1,
            current_page: 0,
            blog_images: {}

        };
        this.handlePagination = this.handlePagination.bind(this);

    }

    handlePagination(event) {
        this.loadPosts();
    }

    loadPosts() {
        axios.get(`${process.env.REACT_APP_API_URL}/posts?page=${this.state.next_page}.json`)
        .then((response) => {
            
            if(response.data.current_page === 1) {
                this.setState({ posts: response.data.posts })
            } else {
                this.setState({ 
                    posts: this.state.posts.concat(response.data.posts)
                 })
            }

            this.setState({ 
                next_page: response.data.next_page,
                current_page: response.data.current_page,
                featured_post: response.data.featured_post,
            });
        })
        .catch();
    }
    componentDidMount() {
        window.scrollTo(0, 0)

        axios.get(`${process.env.REACT_APP_API_URL}/content/blog.json`)
        .then((response) => {
            this.setState({ blog_content: response.data.blog, blog_images: response.data.blog_images });
            window.scrollTo(0, 0)
        })
        .catch();

        this.loadPosts();

        // backto top jquery
        if ($('#back-to-top').length) {
            var scrollTrigger = 100, // px
                backToTop = function () {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop > scrollTrigger) {
                        $('#back-to-top').addClass('show');
                    } else {
                        $('#back-to-top').removeClass('show');
                    }
                };
            backToTop();
            $(window).on('scroll', function () {
                backToTop();
            });
            $('#back-to-top').on('click', function (e) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: 0
                }, 700);
            });
        }
    }

    render() {
        
        const blog_images = this.state.blog_images;
        const backgroundStyle = {
            backgroundImage: `url(${blog_images && blog_images.header_image && blog_images.header_image.url ? blog_images.header_image.url : ''})`
        }
        return (
            <div className="open_menudiv">
                <Header></Header>
                {/* Main Hero Image section  */}
                <div className="hero-slider section blog-hero">
                    <div className="hero-item" id="blog_page" style={backgroundStyle}>
                        <div className="slider-dark-overlay"></div>
                        <div className="container">
                            <div className="row">
                                <div className="hero-content-wrap col">
                                    <div className="hero-content blog-content">
                                        <div className="row">
                                            <div className="col-lg-10 col-md-10 no-padding">
                                                <div className="blog-details">
                                                    {/* <p className="type">offers news</p> */}
                                                    <h1 className="title">{this.state.blog_content && this.state.blog_content.fields && this.state.blog_content.fields.heading}</h1>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 no-padding">
                                                <div className="article-date">
                                                    <div className="date">
                                                        {/* <p>4 JUNE 2019</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Second Section */}
                <section
                    id="other-gems"
                    className="section fix other-gems blogs-articles wow slideInUp"
                    data-wow-duration="1s">
                    {/* <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <Link to="/single-blog">
                                <div className="other-gems-cont-right">
                                    <div className="gems-content-div">
                                        <div className="gems">
                                            <div className="gems-img">
                                                <img src={Bahamas} className="img-responsive" alt="Bahamas yacht charter"/>
                                            </div>
                                            <div className="blog-content">
                                                <p className="title">Bahamas yacht charter special: superyacht ‘My Seanna’ offers 35% discount</p>
                                                <p className="txt">For the first three yacht charters in the Bahamas this
                                                    summer, the 56m/185ft motor yacht ‘My Seanna’ is offering an incredible 35%
                                                    price reduction.</p>
                                                <p className="date">3 June 2019</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </Link>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="gems-content-div">
                                    <div className="gems">
                                        <Link to="/single-blog">
                                            <div className="blog-img">
                                                <img src={passenger} className="img-responsive" alt="Passenger yachts now"/>
                                            </div>
                                            <div className="blog-content">
                                                <p className="title">Passenger yachts now allowed to anchor in Spain</p>
                                                <p className="date">29 MAY 2019</p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="gems small-card">
                                        <Link to="/single-blog">
                                            <div className="blog-img">
                                                <img src={thanda} className="img-responsive" alt="Thanda Island triumphs"/>
                                            </div>
                                            <div className="blog-content">
                                                <p className="title">Thanda Island triumphs at World Travel Awards 2019</p>
                                                <p className="date">3 June 2019</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="background-vector offer-news-vector">
                        <img src={blogvector} className="img-responsive" alt="Background vector art"/>
                    </div>
                </section>

                {/* Third Section */}
                {
                    this.state.featured_post && this.state.featured_post.featured_image
                    ?
                    <section
                        id="offer-news"
                        className="section fix offer-news wow slideInUp"
                        data-wow-duration="1s">
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    <Link to={"/blog/"+ this.state.featured_post.id} >
                                        <div className="offer-news-content">
                                        <div className="slider-dark-overlay"></div>
                                        <div className="offer-news-img">
                                            <img src={this.state.featured_post && this.state.featured_post.featured_image && this.state.featured_post.featured_image.slider.url} className="img-responsive" alt="Sardinia yacht"/>
                                        </div>
                                        <div className="offer-news-img-mobile">
                                            <img src={this.state.featured_post && this.state.featured_post.featured_image && this.state.featured_post.featured_image.slider.url} className="img-responsive" alt="Sardinia yacht"/>
                                        </div>
                                        <div className="offer-news-desc">
                                            <div className="title-div">
                                                <p className="type">FOR A LITTLE INSPIRATION</p>
                                                <h1 className="title">{this.state.featured_post && this.state.featured_post.title }</h1>
                                            </div>
                                            <div className="published-date">
                                                <p>{new Date(this.state.featured_post.created_at).getDate()} / {new Date(this.state.featured_post.created_at).getMonth()} / {new Date(this.state.featured_post.created_at).getFullYear()}</p>
                                            </div>
                                        </div>

                                    </div>
                                    </Link>
                                
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    false
                }

                {/* Fourth Section  */}
                <section
                    id="other-gems"
                    className="section fix other-gems wow slideInUp"
                    data-wow-duration="1s">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="gems-content-div">
                                { this.state && this.state.posts && this.state.posts.map((post, index) => {
                                    return [
                                        <div>
                                        { index === 0 ? 
                                            <div className="other-gems-cont-left">
                                            <div className="heading">
                                                <h1>Latest News</h1>
                                                <p>Read some exciting news from us.</p>
                                            </div>
                                            </div>
                                            :
                                            false
                                        }
                                        {
                                            index % 2 === 0 ?
                                            <Link to={"/blog/"+ post.id} >

                                            <div className="gems">
                                            <div className="blog-img">
                                                <img src={post.featured_image.slider.url} className="img-responsive" alt="blog image1" />
                                            </div>
                                            <div className="blog-content">
                                                <p className="title">{post.title}</p>
                                                <p className="txt">{parse(post.description)}</p>
                                                
                                                <p className="date">{new Date(post.created_at).getDate()} / {new Date(post.created_at).getMonth()} / {new Date(post.created_at).getFullYear()}</p>
                                            </div>
                                            </div>
                                            </Link>
                                            :
                                            false
                                        }
                                    </div>
                                    ]
                                })}
                                </div>
                            </div>
                                
                            <div className="col-lg-6 col-md-6">
                                <div className="other-gems-cont-right">
                                    <div className="gems-content-div">
                                    { this.state && this.state.posts && this.state.posts.map((post, index) => {
                                    return [
                                        <div>
                                        {
                                            index % 2 !== 0 ?
                                            <Link to={"/blog/"+ post.id} >
                                            <div className="gems">
                                            <div className="blog-img">
                                                <img src={post.featured_image.slider.url} className="img-responsive" alt="blog image1" />
                                            </div>
                                            <div className="blog-content">
                                                <p className="title">{post.title}</p>
                                                <p className="txt">{parse(post.description)}</p>
                                                
                                                <p className="date">{new Date(post.created_at).getDate()} / {new Date(post.created_at).getMonth()} / {new Date(post.created_at).getFullYear()}</p>
                                            </div>
                                            </div>
                                            </Link>
                                            :
                                            false
                                        }

                                        {
                                            this.state.posts.length === index + 1 && this.state.next_page !== null?

                                            <div className="show-more-blog">
                                                <button className="btn btn-secondary show-more-btn" onClick={this.handlePagination}>Show more</button>
                                            </div>
                                            :
                                            false
                                        }
                                        </div>

                                    ]
                                    })}
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="background-vector2 other-grms-vector">
                        <img src={vector2} className="img-responsive" alt="Blog vector"/>
                    </div>

                </section>

                {/* slider section */}
                <Footerslider></Footerslider>
                <a href="#pagetop" id="back-to-top" title="Back to top">&uarr;</a>

            </div>
        );
    }
}
export default Blog;